import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PosManagerConfirmModal } from './pos-manager-confirm.modal';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [PosManagerConfirmModal],
  imports: [CommonModule, IonicModule, TranslocoModule],
  exports: [PosManagerConfirmModal]
})
export class PosManagerConfirmModalModule {}
